module.exports = __webpack_public_path__ + "img/i_fxsy_yjs.8743d4af.png";